import script from "./FlattenedPdfComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FlattenedPdfComponent.vue?vue&type=script&setup=true&lang=js"

import "./FlattenedPdfComponent.vue?vue&type=style&index=0&id=2c40ebba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c40ebba"]])

export default __exports__